import React from "react";
import { Route, Routes } from "react-router-dom";
import MainHeader from "./Components/Header";
import MainNav from "./Components/MainNav";
import { useUser } from "../../DataProvider";
import Users from "../Users";
import Categories from "../Categories";
import Articles from "../Articles";
import ComingSoonSection from "../../Components/ComingSoon";

type Props = {};

const index = (props: Props) => {
  const { user } = useUser();
  return (
    <div>
      <MainHeader />
      <div className="flex flex-row p-2">
        <nav
          className=" rounded-md overflow-hidden h-[90vh] overflow-y-scroll sticky top-2
        "
        >
          <MainNav />
        </nav>
        <main className=" p-5 my-2 mx-4 w-full ">
          <Routes>
            {/*    <Route path="/users" element={<Users />} />
            <Route path="/users/add" element={<Users addNewUser />} />
            <Route
              path="/users/edit-permissions/:id"
              element={<Users editPermission />}
            />
            <Route
              path="/users/reset-password/:id"
              element={<Users resetPassword />}
            />
    */}{" "}
            <Route path="/categories" element={<Categories />} />
            <Route
              path="/categories/edit-seo/:id"
              element={<Categories editSeo />}
            />
            <Route
              path="/categories/edit-title/:id"
              element={<Categories editTitle />}
            />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/add" element={<Articles addNewArticle />} />
            <Route
              path="/articles/edit-seo/:id"
              element={<Articles editSeo />}
            />
            <Route
              path="/articles/edit-image/:id"
              element={<Articles editImage />}
            />
            <Route
              path="/articles/edit-content/:id"
              element={<Articles editContent />}
            />
            <Route
              path="/articles/manage-attachments/:id"
              element={<Articles manageGallary />}
            />
            <Route
              path="/articles/edit-main-info/:id"
              element={<Articles editMainInfo />}
            />
            <Route path="/main-news" element={<ComingSoonSection />} />
            <Route path="/statistics" element={<ComingSoonSection />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default index;
